import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button, Form, Input, InputDate, Select, Tooltip } from 'Components';

import {
  resetPasswordCognito
} from "Redux/actions";

const ResetPassword = ({showResetEmail, onChangeResetPassword, subUserInfo }) => {
  const { messages } = useIntl();
  const dispatch = useDispatch();

  const resetPassword = (userId) => {
    dispatch(resetPasswordCognito({ userId }));
  };

  return(
    <>
      {/* Reset Password Subuser */}
      <Modal
      size={'small'}
      open={showResetEmail}
      handleClose={() => onChangeResetPassword(false)}
      title={`${messages["subUser_resetPassword"]}`}
      >
      <ModalBody>
        <div style={{ padding: '0px 25px' }}>
          <p style={{ overflowWrap: 'anywhere' }}>
            {`${messages['subUser_resetPasswordMessage']}`}
          </p>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          id={'btn-cancel-vehicle'}
          type="button"
          onClick={() => onChangeResetPassword(false)}
          className="btn-cancel"
        >
          {messages['cancel']}
        </Button>

        <Button
          id={'btn-schedule'}
          type="button"
          onClick={(e) => {
            e.preventDefault();
            onChangeResetPassword(false);
            const id = Array.isArray(subUserInfo) ? subUserInfo[0]?.id :subUserInfo.id
            resetPassword(id);
          }}
          className="btn-red"
        >
          {messages['subUser_resetCognito']}
        </Button>
      </ModalFooter>
      </Modal>
    </>
  )
}

export default ResetPassword;